import React from "react"
import { Link } from "gatsby"
import { mdiArrowRight } from "@mdi/js"

// Project components
import { Bin, Box, Button, FlexGrid, Heading, Wrapper } from "components"

const BinsSection = ({ data, filter, id }) => {
  return (
    <>
      {/* We only render the section if it has props set */}
      {data.title && (
        <Wrapper id={id}>
          {data.title && <Heading size={800}>{data.title}</Heading>}

          {/* Bins */}
          {data.bins && (
            <Box mt={["layout.4", null, "layout.6"]}>
              <FlexGrid
                content={data.bins.map((bin, index) => ({
                  width: ["100%", "33.333%"],
                  children: <Bin {...bin} key={"bins" + index} />,
                }))}
                gutterY={[2, 4]}
                gutterX={[2, 2, 16]}
              />
            </Box>
          )}

          {/* Button */}
          <Button
            as={Link}
            to={"/bins/?filter=" + data.filter}
            iconAfter={mdiArrowRight}
            intent="primary"
            appearance="primary"
            height={[40, 48]}
            mt={["layout.4", null, "layout.6"]}
          >
            More Bin Options
          </Button>
        </Wrapper>
      )}
    </>
  )
}

export default BinsSection
